import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import styles from "./styles/how-to-train-modal.module.scss";
import FilledButton from "@/components/common/filled-button";
import QuestionAnswer from "@/components/pages/custom/components/question-answer";
import UnfilledButton from "@/components/common/unfilled-button";
import Link from "next/link";

const HowToTrainModal = () => {
  const { hideModal, showModal } = useGlobalModalContext();
  const showYoutubeEmbedModal = () => {
    showModal({
      type: "youtube_embed_modal",
      props: {
        title: "AudioModify Tutorial",
        desktopYoutubeVideoId: "1AbBMJnsujE",
        mobileYoutubeVideoId: "1AbBMJnsujE",
      },
    });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>How to use?</div>
      <div className={styles.faq_wrapper}>

        <QuestionAnswer
          question={"What is a dataset?"}
          answer={
            "- Audio file containing vocals." +
            "- Preferably 10+ minutes in length." +
            "- MP3, WAV or OGG format."
          }
        />

	 <QuestionAnswer
          question={"Will my custom voice be private?"}
          answer={
            "Yes! Only you will be able to access, see and use your custom voice model!"
          }
        />
        <QuestionAnswer
          question={"What types of files can I download?"}
          answer={"mp3, wav, ogg"}
        />

        <QuestionAnswer
          question={"How do I name the voice?"}
          answer={
            "The name must be entered without spaces and special characters"
          }
        />
        <QuestionAnswer
          question={"In what language can I upload a file?"}
          answer={
            "Currently, the following languages are available: English, Italian, " +
            "Korean, “Other”, but we are working on expanding the list.\n" +
            "Choosing a language will help train the voice better."
          }
        />
        <QuestionAnswer
          question={"Voice training takes a long time?"}
          answer={
            "This can happen if the dataset is long in duration or large in size. To " +
            "speed up training, consider using a smaller dataset."
          }
        />
      </div>
      <div className={styles.tutorial_buttons}>
        <Link
          href={"/how-to-use/custom-voice-tips"}
          onClick={() => {
            hideModal();
          }}
        >
          <UnfilledButton
            padding={"12px 24px"}
            text={"VOCAL CREATION GUIDE"}
            borderColor={"#F9A825"}
          />
        </Link>
      </div>
      <FilledButton
        text="OK"
        onClick={() => {
          hideModal();
        }}
      />
    </div>
  );
};

export default HowToTrainModal;
